var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 61.6667C70 66.27 66.27 70 61.6667 70H18.3333C13.7317 70 10 66.27 10 61.6667V18.3333C10 13.73 13.7317 10 18.3333 10H61.6667C66.27 10 70 13.73 70 18.3333V61.6667Z",
    fill: "#2f2f3a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.6667H28.3333V60H20V31.6667ZM24.1417 28.3333H24.095C21.6083 28.3333 20 26.48 20 24.165C20 21.8 21.6583 20 24.19 20C26.725 20 28.2867 21.8 28.3333 24.165C28.3333 26.4783 26.725 28.3333 24.1417 28.3333ZM60 60H51.6667V44.835C51.6667 41.1717 49.625 38.6717 46.3467 38.6717C43.845 38.6717 42.4917 40.3583 41.835 41.9883C41.595 42.5717 41.6667 44.185 41.6667 45V60H33.3333V31.6667H41.6667V36.0267C42.8683 34.1667 44.75 31.6667 49.5633 31.6667C55.5267 31.6667 59.9983 35.4167 59.9983 43.79L60 60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.035bfc915bac6180ea633bc13b97e85f.svg";
export { ForwardRef as ReactComponent };